/**
 * SettingsPage - Настройки (legacy)
 */

import React, { useEffect, useState } from "react";
import { Modal } from "../../components/UI";
import { ucpService } from "../../api/services/ucpService";
import { whirlpool } from "hash-wasm";
import { QRCodeSVG } from "qrcode.react";

const SettingsPage = () => {
    const [loading, setLoading] = useState(true);
    const [userInfo, setUserInfo] = useState({});
    const [passw, setPassw] = useState("");
    const [isGAuthChecked, setIsGAuthChecked] = useState(false);
    const [gAuthSecretKey, setGAuthSecretKey] = useState("");
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [isGAuthModalOpen, setGAuthModalOpen] = useState(false);
    const [page, setPage] = useState(0);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const result = await ucpService.getUserInfo();
                setUserInfo(result || {});
                if (result?.gauth_enabled) setIsGAuthChecked(true);
            } catch (err) {
                console.error(err.message);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, []);

    const handleExit = () => {
        localStorage.clear();
        window.location.href = "../../";
    };

    const handleChangePassword = async () => {
        const result = await whirlpool(passw);
        if (result.toUpperCase() === localStorage.getItem("user-password")) {
            openLoginModal();
        }
    };

    const openLoginModal = () => {
        setModalIsOpen(true);
    };

    const closeLoginModal = () => {
        setModalIsOpen(false);
    };

    const handleConfirmTwoAuth = () => {
        setGAuthModalOpen(false);
    };

    const disableGAuthRequest = async () => {
        try {
            await ucpService.disableGoogleTwoAuth();
        } catch (err) {
            console.error("Ошибка соединения:", err);
        }
    };

    const closeGAuthModal = () => {
        setGAuthModalOpen(false);
        setIsGAuthChecked(false);
        disableGAuthRequest();
    };

    const handleToggle = async (event) => {
        const checked = event.target.checked;
        setIsGAuthChecked(checked);
        if (checked === true) {
            setGAuthModalOpen(true);
            try {
                const data = await ucpService.newSecretKey();
                if (data?.code === 200) {
                    setGAuthSecretKey(data.object);
                } else {
                    console.log(data?.status, ", code: ", data?.code);
                    setGAuthSecretKey(data?.status);
                }
            } catch (err) {
                console.error("Ошибка соединения:", err);
            }
        } else {
            disableGAuthRequest();
        }
    };

    const submitChangePassword = async (event) => {
        event.preventDefault();
        const formData = new FormData(event.target);
        const payload = Object.fromEntries(formData.entries());
        if (payload.password !== payload.re_password) {
            return null;
        }
        try {
            const newPassHash = (
                await whirlpool(payload.password)
            ).toUpperCase();
            const data = await ucpService.changeUserPassword(newPassHash);
            if (data === true) {
                localStorage.setItem("user-password", newPassHash);
                closeLoginModal();
            }
        } catch (err) {
            console.error("Ошибка соединения:", err);
        }
    };

    const changePassContent = (
        <div className="modal-content-container">
            <span className="modal-title">СМЕНА ПАРОЛЯ</span>
            <form
                onSubmit={submitChangePassword}
                style={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    gap: "20px",
                    alignItems: "center",
                }}
            >
                <input
                    className="auth-input-form"
                    placeholder="Новый пароль*"
                    name="password"
                    type="password"
                />
                <input
                    className="auth-input-form"
                    placeholder="Повторите новый пароль*"
                    name="re_password"
                    type="password"
                />
                <div className="modal-buttons">
                    <button
                        className="ucp-simple-yellow-button"
                        type="submit"
                        style={{ flexGrow: 1 }}
                    >
                        СМЕНИТЬ
                    </button>
                    <button
                        className="ucp-simple-yellow-button ucp-white-modified-button"
                        type="button"
                        onClick={closeLoginModal}
                        style={{ flexGrow: 1 }}
                    >
                        ОТМЕНА
                    </button>
                </div>
            </form>
        </div>
    );

    const gAuthModalContent = (
        <div className="modal-content-container">
            <span className="modal-title">
                НАСТРОЙКА ДВУХФАКТОРНОЙ АУТЕНТИФИКАЦИИ
            </span>
            <span>
                Пожалуйста, остканируйте данный QR код или воспользуйтесь
                следующим кодом для настройки двухфакторной аутентификации:
            </span>
            <span style={{ fontSize: "16px", fontWeight: "bold" }}>
                {gAuthSecretKey || ""}
            </span>
            {gAuthSecretKey && (
                <div style={{ textAlign: "center" }}>
                    <QRCodeSVG
                        value={`otpauth://totp/Medieval:${localStorage.getItem("user-login")}?secret=${gAuthSecretKey}&issuer=Medieval`}
                        size={280}
                    />
                </div>
            )}
            <div className="modal-buttons">
                <button
                    className="ucp-simple-yellow-button"
                    onClick={handleConfirmTwoAuth}
                    style={{ flexGrow: 1 }}
                >
                    ПРИМЕНИТЬ
                </button>
                <button
                    className="ucp-simple-yellow-button ucp-white-modified-button"
                    onClick={closeGAuthModal}
                    style={{ flexGrow: 1 }}
                >
                    ОТМЕНА
                </button>
            </div>
        </div>
    );

    function formatTimeWithOffset(timeString, offsetHours) {
        const date = new Date(timeString);
        date.setHours(date.getHours() + offsetHours);
        return date
            .toISOString()
            .replace("T", " ")
            .replace("Z", "")
            .replace(".000", "");
    }

    if (loading) {
        return (
            <div
                className="shop-loader-container ucp-dashboard-character-loader"
                role="status"
                aria-live="polite"
                aria-label="Загрузка"
            >
                <div className="shop-loader" />
            </div>
        );
    }

    return (
        <div className="settings-page">
            <Modal
                isOpen={modalIsOpen}
                onClose={closeLoginModal}
                className="modal--settings-resetpass"
            >
                {changePassContent}
            </Modal>

            <Modal
                isOpen={isGAuthModalOpen}
                onClose={closeGAuthModal}
                className="modal--settings-gauth"
            >
                {gAuthModalContent}
            </Modal>

            {/* Header: Back Button + Tabs */}
            <div className="settings-page__header">
                <button
                    className="ucp-simple-blur-button ucp-button-back settings-page__back"
                    onClick={() => (window.location.href = "/ucp")}
                >
                    НАЗАД
                </button>

                <div className="settings-page__tabs">
                    <button
                        className={`tab-button ${page === 0 ? "tab-button--active" : ""}`}
                        onClick={() => setPage(0)}
                    >
                        ЛИЧНЫЕ ДАННЫЕ И БЕЗОПАСНОСТЬ
                    </button>
                    <button
                        className={`tab-button ${page === 1 ? "tab-button--active" : ""}`}
                        onClick={() => setPage(1)}
                    >
                        ИСТОРИЯ АВТОРИЗАЦИЙ
                    </button>
                </div>
            </div>

            {/* Content */}
            <div className="settings-page__content">
                {page === 0 && (
                    <div className="settings-grid">
                        {/* Row 1: Username and Registration */}
                        <div className="settings-field">
                            <div className="settings-field__value settings-field__value--with-icon">
                                {localStorage.getItem("user-login")}
                            </div>
                        </div>
                        <div className="settings-field">
                            <div className="settings-field__value settings-field__value--date">
                                ЗАРЕГИСТРИРОВАН{" "}
                                {userInfo.registrationDate
                                    ? userInfo.registrationDate.split("-")[2] +
                                      "." +
                                      userInfo.registrationDate.split("-")[1] +
                                      "." +
                                      userInfo.registrationDate.split("-")[0]
                                    : ""}
                            </div>
                        </div>

                        {/* Premium note */}
                        <p className="settings-premium">
                            Нет активной Premium подписки*
                        </p>

                        {/* Row 2: Email */}
                        <div className="settings-field">
                            <h3 className="settings-field__label">
                                КОНТАКТНЫЙ E-MAIL
                            </h3>
                            <div className="settings-field__value">
                                {userInfo.email}
                            </div>
                        </div>

                        {/* Row 2: Password */}
                        <div className="settings-field">
                            <h3 className="settings-field__label">ПАРОЛЬ</h3>
                            <div className="settings-field__row">
                                <div className="settings-field__value">
                                    <input
                                        type="password"
                                        placeholder="Введите действующий пароль..."
                                        maxLength={32}
                                        value={passw}
                                        onChange={(e) =>
                                            setPassw(e.target.value)
                                        }
                                    />
                                </div>
                                <button
                                    className="settings-btn"
                                    onClick={handleChangePassword}
                                >
                                    СМЕНИТЬ ПАРОЛЬ
                                </button>
                            </div>
                        </div>

                        {/* Row 3: Forum Account - full width */}
                        <div className="settings-field settings-grid--full-width">
                            <h3 className="settings-field__label">
                                ФОРУМНЫЙ АККАУНТ
                            </h3>
                            <div className="settings-field__value">
                                В РАЗРАБОТКЕ
                            </div>
                        </div>

                        {/* Row 4: Toggles */}
                        <div className="settings-toggles">
                            <div className="settings-toggle">
                                <h3 className="settings-toggle__label">
                                    TELEGRAM
                                </h3>
                                <label className="switch">
                                    <input type="checkbox" disabled />
                                    <span className="slider round"></span>
                                </label>
                            </div>
                            <div className="settings-toggle">
                                <h3 className="settings-toggle__label">
                                    GOOGLE AUTHENTICATOR
                                </h3>
                                <label className="switch">
                                    <input
                                        type="checkbox"
                                        checked={isGAuthChecked}
                                        onChange={handleToggle}
                                    />
                                    <span className="slider round"></span>
                                </label>
                            </div>
                        </div>

                        {/* Exit Button */}
                        <button
                            className="settings-btn settings-btn--exit"
                            onClick={handleExit}
                        >
                            ВЫХОД
                        </button>
                    </div>
                )}

                {page === 1 && (
                    <div className="settings-history">
                        <table>
                            <thead>
                                <tr>
                                    <th>ДАТА</th>
                                    <th>IP</th>
                                    <th>КЛИЕНТ</th>
                                    <th>ПЛАТФОРМА</th>
                                </tr>
                            </thead>
                            <tbody>
                                {userInfo.ucpAuthLogs?.map((log) => (
                                    <tr key={log.id}>
                                        <td>
                                            {formatTimeWithOffset(log.time, 3)}
                                        </td>
                                        <td>{log.ip}</td>
                                        <td>{log.client}</td>
                                        <td>{log.platform}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
        </div>
    );
};

export default SettingsPage;
